import { eventsData as clubEventsData } from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'
import ClubDetailInfoBanner from 'www/vue_components/common/Club/components/core/ClubDetailInfoBanner/ClubDetailInfoBanner.vue'
import ClubInfoModal from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/common/ClubInfoModal.vue'
import ClubServiceDiscountControl from 'www/vue_components/common/Club/components/core/ClubServiceDiscountControl/ClubServiceDiscountControl.vue'

import {
  debounce,
  dispatchCustomEventGlobally,
} from 'www/utils'

import { NAMESPACE } from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/constants'

import {
  getNodesData,
  renderComponent,
  getPropsFromHTML,
  destroyComponents,
  getIsEnabledLpuClub,
} from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/modules/ServicesClubLogic/functions'

class ServicesClubLogic {
  hasObserver = false

  isUpdatedPage = false

  switchesState = false

  vueInstances = []

  vueDetailBannerInstance = null

  vueModalInfoInstance = null

  nodes = getNodesData()

  userClubData = window.USER.club

  userPhone = window.USER.userPhone

  constructor() {
    this._createObserver()
    this._createComponentsListeners()
    this._renderInfoModal()

    this.init()
  }

  init() {
    this._renderServiceDiscountControls()
    this._renderDetailBanner()
  }

  // other

  _createComponentsListeners() {
    window.addEventListener('club-info-banner:click', this._clubInfoBannerClick.bind(this))
    window.addEventListener('club-discount-switch:click', this._clubDiscountSwitchClickListener.bind(this))
    window.addEventListener('club-discount-switch:change-state', this._clubDiscountSwitchChangeStateListener.bind(this))
    window.addEventListener('club-service-discount:updated-user-data', this._handleUpdatedUserClubData.bind(this))
    window.addEventListener(clubEventsData.userAuth.confirmed, this._handleUpdatedUserPhone.bind(this))
  }

  _createObserver() {
    if (this.hasObserver) {
      return
    }

    this.hasObserver = true

    const target = document.querySelector(`[${NAMESPACE.observerContainerSlots}]`)

    if (!target) {
      return
    }

    const callback = debounce(this._mutationListener.bind(this), 1000)

    new MutationObserver(callback).observe(target, {
      childList: true,
    })
  }

  _changeDisplayPriceList() {
    this.nodes.lpuCardsPriceListNodes.forEach(({ priceListNodesClub, priceListNodesDefault }) => {
      if (!priceListNodesClub.length || !priceListNodesDefault.length) {
        return
      }

      const isUsedClub = getIsEnabledLpuClub(priceListNodesClub[0])
                && (this.userClubData.isInClub || this.switchesState)

      priceListNodesClub.forEach(node => { node.hidden = !isUsedClub })
      priceListNodesDefault.forEach(node => { node.hidden = isUsedClub })
    })
  }

  // listeners

  _mutationListener() {
    this.nodes = getNodesData()
    this._changeDisplayPriceList()

    this.isUpdatedPage = true

    destroyComponents(this.vueInstances)

    this.vueInstances = []

    dispatchCustomEventGlobally('club-discount-switch:change-state', {
      isEnabled: this.switchesState,
    })

    this.init()
  }

  _clubInfoBannerClick() {
    dispatchCustomEventGlobally('club-info-modal:open')
  }

  _clubDiscountSwitchClickListener({ detail }) {
    dispatchCustomEventGlobally('club-discount-switch:change-state', detail)
    dispatchCustomEventGlobally('club-detail-info-banner:change-state', detail)
  }

  _clubDiscountSwitchChangeStateListener({ detail }) {
    this.switchesState = detail.isEnabled

    this._changeDisplayPriceList()
  }

  _handleUpdatedUserClubData({ detail }) {
    this.userClubData = { ...this.userClubData, ...detail.userClubData }

    if (this.vueDetailBannerInstance && this.userClubData.isInClub) {
      this.vueDetailBannerInstance.$destroy()
      this.vueDetailBannerInstance.$el.remove()
    }

    this._updateInfoModal()
    this._changeDisplayPriceList()
  }

  _handleUpdatedUserPhone({ detail }) {
    this.userPhone = detail.userPhone

    this._updateInfoModal()
  }

  // render

  _renderServiceDiscountControls() {
    const { mountServiceDiscountControlNodeList } = this.nodes

    if (!mountServiceDiscountControlNodeList.length) {
      return
    }

    const props = {
      userClubData: this.userClubData,
    }

    if (this.isUpdatedPage) {
      props.isSwitchEnabled = this.switchesState
    }

    mountServiceDiscountControlNodeList.forEach(node => {
      if (getIsEnabledLpuClub(node)) {
        const instance = renderComponent(node, props, ClubServiceDiscountControl)

        this.vueInstances.push(instance)
      }
    })
  }

  _renderDetailBanner() {
    const { mountBannerDetailNode } = this.nodes

    if (!mountBannerDetailNode) {
      return
    }

    const propsList = getPropsFromHTML([mountBannerDetailNode])

    if (!propsList.length) {
      return
    }

    const [{ node, props }] = propsList

    if (this.isUpdatedPage) {
      props.hide = !this.switchesState
    }

    this.vueDetailBannerInstance = renderComponent(node, props, ClubDetailInfoBanner)

    this.vueInstances.push(this.vueDetailBannerInstance)
  }

  _renderInfoModal() {
    const props = {
      showClubServicePriceInfo: true,
      userClubData: this.userClubData,
      userPhone: this.userPhone,
    }

    this.vueModalInfoInstance = renderComponent(this.nodes.mountModalInfoNode, props, ClubInfoModal)
  }

  _updateInfoModal() {
    if (!this.vueModalInfoInstance) {
      return
    }

    this.vueModalInfoInstance.$destroy()

    this._renderInfoModal()
  }
}

export default ServicesClubLogic
